export enum WorkOrderBillingStatuses {
  READY_FOR_BILLING = 'ready_for_billing',
  REJECT_NOT_READY_FOR_BILLING = 'reject_not_ready_for_billing'
}
